module.exports = __webpack_public_path__ + "static/media/tl_report.20203dfb.svg";